import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface OperatorStore {
   showOperatorSection: boolean
   toggleOperatorSection: () => void
   setShowOperatorSection: (show: boolean) => void
}

export const useOperatorStore = create<OperatorStore>()(
   persist(
      (set) => ({
         showOperatorSection: true,
         toggleOperatorSection: () =>
            set((state) => ({
               showOperatorSection: !state.showOperatorSection,
            })),
         setShowOperatorSection: (show) => set({ showOperatorSection: show }),
      }),
      {
         name: 'operator-storage',
      }
   )
)
